import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { Note } from 'src/app/shared/models/clients/note';

@Component({
  selector: 'app-create-edit-note',
  templateUrl: './create-edit-note.component.html',
  styleUrls: ['./create-edit-note.component.scss']
})
export class CreateEditNoteComponent implements OnInit {

  public note: Note;
  public clientId: number;
  @ViewChild('noteModal') noteModal;
  @Output() submit: EventEmitter<Note> = new EventEmitter<Note>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: ClientsApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(note: Note) {
    this.note = Object.assign(new Note(), note);
    this.modalRef = this.modalService.open(this.noteModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.note.id) {
      this.spinner.show();
      this.api.updateClientNote(this.note.clientId, this.note).subscribe(
        n => {
          this.spinner.hide();
          this.submit.emit(n);
        }
      )
    } else {
      this.spinner.show();
      this.api.createClientNote(this.note.clientId, this.note).subscribe(
        n => {
          this.spinner.hide();
          this.submit.emit(n);
        }
      )
    }
  }
}
